import { Box, Skeleton, styled } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import useScreenWidth from '../../hooks/useScreenWidth'
import HiddenDesktop from '../../styles/HiddenDesktop'
import HiddenMobile from '../../styles/HiddenMobile'
import CardsSkeleton from './CardsSkeleton'

const NavBarContainer = styled('div')(({ theme }) => ({
  height: 50,
  minHeight: 50,
  maxHeight: 50,
  display: 'flex',
  left: 0,
  justifyContent: 'space-between',
  boxSizing: 'border-box',
  alignItems: 'center',
  padding: '0px 24px',
  backgroundColor: '#FAFAFA',
  position: 'fixed',
  top: 0,
  zIndex: 1200,
  width: '100%'
}))

const SkeletonButton = styled(Skeleton)(({ theme }) => ({
  borderRadius: 8,
  height: 88,
  width: '100%',
  boxShadow: '23px -23px 43px #FFFFFF, 28px 28px 50px rgba(13, 39, 80, 0.16)'
}))

const ContainerBtnMenuMobile = styled('div')(({ theme }) => ({
  paddingTop: 8,
  paddingBottom: 10,
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center'
}))

function HomeSkeleton() {
  const isMobile = useScreenWidth(960)

  return (
    <Box sx={{ maxWidth: '1920px', margin: '0 auto' }}>
      <NavBarContainer>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Skeleton animation="wave" width={59} height={26} variant="rectangular" style={{ marginRight: 32 }} />
          <HiddenMobile display="flex">
            <Skeleton animation="wave" width={87} height={27} variant="text" style={{ marginRight: 24 }} />
            <Skeleton animation="wave" width={79} height={27} variant="text" style={{ marginRight: 24 }} />
            <Skeleton animation="wave" width={63} height={27} variant="text" style={{ marginRight: 24 }} />
            <Skeleton animation="wave" width={80} height={27} variant="text" style={{ marginRight: 24 }} />
            <Skeleton animation="wave" width={80} height={27} variant="text" style={{ marginRight: 24 }} />
          </HiddenMobile>
          <HiddenDesktop>
            <Skeleton animation="wave" width={24} height={24} variant="circular" style={{ marginLeft: 18 }} />
          </HiddenDesktop>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <HiddenMobile display="flex" alignItems="center">
            <Skeleton animation="wave" width={208} height={32} variant="rectangular" sx={{ borderRadius: 8 }} />
            <Skeleton animation="wave" width={24} height={24} variant="circular" style={{ marginLeft: 18 }} />
          </HiddenMobile>
          <Skeleton animation="wave" width={24} height={24} variant="circular" style={{ marginLeft: 18 }} />
          <Skeleton animation="wave" width={24} height={24} variant="circular" style={{ marginLeft: 18 }} />
          <Skeleton animation="wave" width={24} height={24} variant="circular" style={{ marginLeft: 18, marginRight: 8 }} />
        </Box>
      </NavBarContainer>
      {/* Bradcrumb  */}
      <HiddenDesktop>
        <Box height={50} />
      </HiddenDesktop>
      {/* Rectangle of Slider */}
      <HiddenMobile>
        <Skeleton variant="rectangular" animation="wave" height="27.5rem" width="100%" style={{ maxWidth: '1920px' }} />
      </HiddenMobile>
      <HiddenDesktop>
        <Box p={2}>
          <Skeleton variant="rectangular" animation="wave" height="144px" width="100%" sx={{ borderRadius: 8 }} />
        </Box>
      </HiddenDesktop>
      {/* Buttons */}
      <HiddenMobile>
        <Box py={4} display="flex" justifyContent="center">
          <Skeleton animation="wave" width={312} height={46} variant="text" />
        </Box>
        <Box display="flex" alignItems="center" gap="48px" pl={7} pr={7} pb={4}>
          <SkeletonButton variant="rectangular" animation="wave" />
          <SkeletonButton variant="rectangular" animation="wave" />
          <SkeletonButton variant="rectangular" animation="wave" />
          <SkeletonButton variant="rectangular" animation="wave" />
        </Box>
      </HiddenMobile>
      {/* Menu mobile */}
      <HiddenDesktop>
        <Box
          sx={{
            position: 'fixed',
            left: 0,
            right: 0,
            top: 'auto',
            bottom: 0,
            padding: 8,
            boxShadow: 'none',
            backgroundColor: 'transparent',
            zIndex: 1200
          }}
        >
          <Box sx={{ boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.16)', borderRadius: 16, backgroundColor: '#FAFAFA', display: 'flex' }}>
            <ContainerBtnMenuMobile>
              <Skeleton variant="rectangular" animation="wave" height="24px" width="24px" />
              <Skeleton animation="wave" width={65} height={20} variant="text" />
            </ContainerBtnMenuMobile>
            <ContainerBtnMenuMobile>
              <Skeleton variant="rectangular" animation="wave" height="24px" width="24px" />
              <Skeleton animation="wave" width={60} height={20} variant="text" />
            </ContainerBtnMenuMobile>
            <ContainerBtnMenuMobile>
              <Skeleton variant="rectangular" animation="wave" height="24px" width="24px" />
              <Skeleton animation="wave" width={46} height={20} variant="text" />
            </ContainerBtnMenuMobile>
            <ContainerBtnMenuMobile>
              <Skeleton variant="rectangular" animation="wave" height="24px" width="24px" />
              <Skeleton animation="wave" width={68} height={20} variant="text" />
            </ContainerBtnMenuMobile>
            <ContainerBtnMenuMobile>
              <Skeleton variant="rectangular" animation="wave" height="24px" width="24px" />
              <Skeleton animation="wave" width={48} height={20} variant="text" />
            </ContainerBtnMenuMobile>
          </Box>
        </Box>
      </HiddenDesktop>
      <Grid
        container
        spacing={isMobile ? 5 : 4}
        sx={theme => ({
          width: '100%',
          margin: 0,
          [theme.breakpoints.up('sm')]: {
            margin: '-40px auto 0px'
          }
        })}
      >
        <Grid xs={12} md={7} style={isMobile ? { paddingTop: 2, paddingBottom: 2 } : { padding: 16 }}>
          <Grid xs={12} sx={{ borderBottom: '1px solid  #C7CCD1', marginTop: 32, marginBottom: 24 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Skeleton animation="wave" width={120} height={46} variant="text" />
              <Skeleton animation="wave" width={65} height={30} variant="text" />
            </Box>
          </Grid>
          <Grid container spacing={2}>
            <Grid xs={12} md={6} lg={4}>
              <CardsSkeleton />
            </Grid>
            <Grid xs={12} md={6} lg={4}>
              <CardsSkeleton />
            </Grid>
            <Grid xs={12} md={6} lg={4}>
              <CardsSkeleton />
            </Grid>
          </Grid>
          <Grid xs={12} sx={{ borderBottom: '1px solid  #C7CCD1', marginTop: 32, marginBottom: 24 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Skeleton animation="wave" width={120} height={46} variant="text" />
              <Skeleton animation="wave" width={65} height={30} variant="text" />
            </Box>
          </Grid>
          <Grid container spacing={2}>
            <Grid xs={12} md={6} lg={4}>
              <CardsSkeleton />
            </Grid>
            <Grid xs={12} md={6} lg={4}>
              <CardsSkeleton />
            </Grid>
            <Grid xs={12} md={6} lg={4}>
              <CardsSkeleton />
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={12} md={5} style={isMobile ? { paddingTop: 0 } : { padding: 16 }}>
          <Box>
            <Grid xs={12} sx={{ borderBottom: '1px solid  #C7CCD1', marginTop: 32, marginBottom: 24 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Skeleton animation="wave" width={120} height={46} variant="text" />
                <Skeleton animation="wave" width={65} height={30} variant="text" />
              </Box>
            </Grid>
            <Skeleton variant="rectangular" animation="wave" height={694} width="100%" sx={{ borderRadius: 8 }} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default HomeSkeleton
